import Q1 from './Q1';

export default Q1;
